import React from 'react';
import { Grid, makeStyles, Typography, Checkbox, styled } from '@material-ui/core';

const useStyles = makeStyles({
  title: {
    fontFamily: 'Lato',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22.4px',
  },
  parametersText: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16.8px',
    color: 'rgba(102, 112, 133, 1)',
  },
  columnText: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16.8px',
    color: 'rgba(16, 24, 43, 1)',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});
const CustomStyledCheckbox = styled(Checkbox)(() => ({
  color: 'rgba(208, 213, 221, 1)',
  '&.Mui-checked': {
    color: 'rgba(98, 47, 238, 1)',
  },
  '&.MuiCheckbox-root': {
    borderColor: 'rgba(208, 213, 221, 1)',
  },
}));

const ScoreParameters = ({ handleChange, data, metaColumns }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography className={classes.title}>Score parameters</Typography>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography className={classes.columnText}>Column Names</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.columnText} align="center">
              Is Scoring Parameters
            </Typography>
          </Grid>
        </Grid>
        {metaColumns.map((column) => (
          <Grid container item spacing={2} className={classes.rowContainer}>
            <Grid item xs={6}>
              <Typography className={classes.parametersText}>{`${column.columnName}(${column.dataType})`}</Typography>
            </Grid>
            <Grid item xs={6} container justifyContent="center">
              <CustomStyledCheckbox
                checked={
                  data?.scoreBreakupParameters?.find((item) => item.columnName === column.columnName)?.isDisplayed
                }
                size="small"
                value={column.columnName}
                name="scoreBreakupParameters"
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default ScoreParameters;
